<script>
import SkyList from 'sky-list';
import SkySearchMixin from 'sky-search/sky-search.mixin';

const parameters = {
	keywords: '',
	jobtitle: '',
	department: '',
};

export default {
	mixins: [SkySearchMixin],
	data() {
		return {
			list: new SkyList({
				api: '/umbraco/api/employees/search/',
				pagination: true,
			}, parameters),
			parameters,
		};
	},
	created() {
		/**
		 * Populate keywords from list in case it has intial value
		 * (from url string for instance)
		 */
		Object.keys(this.parameters).forEach((key) => {
			if (key in this.list.params) {
				this.parameters[key] = this.list.params[key];
			}
		});

		// uncomment for init search
		// this.list.update();
	},
	watch: {
		parameters: {
			handler() {
				// Keep list params in sync
				Object.keys(this.parameters).forEach((key) => {
					if (this.list.params[key] !== this.parameters[key]) {
						this.list.params[key] = this.parameters[key];
						// Reset offset if params have changed
						this.list.params.offset = 0;
					}
				});
				this.update();
			},
			deep: true,
		},
	},
	methods: {
		update() {
			this.list.update();
		},
	},
};
</script>

<style src="./RoPersonSearch.scss"></style>
<template src="./RoPersonSearch.html"></template>



// WEBPACK FOOTER //
// RoPersonSearch.vue?6aee2c05